var exports = {
  "a": "Box__0uWnDs",
  "D": "Heading__DjOdsj",
};

module.exports = exports;
